var exports = {
  "embla-root": "x43cbe9c2--b8611f--embla-root",
  "embla-viewport": "x43cbe9c2--b8611f--embla-viewport",
  "phone": "x43cbe9c2--b8611f--phone",
  "embla-container": "x43cbe9c2--b8611f--embla-container",
  "tablet": "x43cbe9c2--b8611f--tablet",
  "desktop": "x43cbe9c2--b8611f--desktop",
  "embla-slide": "x43cbe9c2--b8611f--embla-slide",
};

module.exports = exports;
